// extracted by mini-css-extract-plugin
export var image = "_in-0";